
export const TEAM_TYPEAHEAD_RESULTS = 'teams.typeAhead.results';
export const teamTypeAheadResults = teams => ({
  type: TEAM_TYPEAHEAD_RESULTS,
  teams,
});

export const FIRST_SEASON_CREATE_TEAM = 'teams.firstSeasonForm.createTeam';

